import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { closeIcon } from '@justgiving/icons';
import Svg from '@justgiving/svg';

import Button from '../Button/Button';
import usePageViewTracking from '../../hooks/usePageViewTracking';

import styles from './ConfirmationModal.scss';

interface Props {
  children: ReactNode;
  onConfirm: () => void;
  onDismiss: () => void;
  confirmButtonText: string;
  dismissButtonText: string;
  modalTitle: string;
}

export const ConfirmationModal = React.forwardRef(
  (
    {
      children,
      modalTitle,
      onDismiss,
      onConfirm,
      confirmButtonText,
      dismissButtonText,
    }: Props,
    ref?: React.Ref<HTMLDivElement>,
  ) => {
    const { t } = useTranslation('common', { useSuspense: false });

    usePageViewTracking({
      event: 'page view',
      subtype: 'stop sharing confirmation',
      page_section: 'strava -> manage strava settings',
    });

    return (
      <div
        aria-label={t('strava.confirmationModal.label')}
        className={`${styles.confirmationModal} jg-display-flex jg-flex-column jg-flex-ais`}
        ref={ref}
      >
        <header className="jg-display-flex jg-flex-column jg-flex-asc ">
          <Svg
            markup={closeIcon}
            aria-label={'closeIcon'}
            className={`${styles.closeIcon} jg-flex-ase`}
            onClick={onDismiss}
          />
          <span className={`${styles.title} jg-flex-asc`}>{modalTitle}</span>
        </header>
        {children}

        <Button
          className="jg-btn jg-space-mtlg"
          onClick={onConfirm}
          type="button"
        >
          {confirmButtonText}
        </Button>

        <Button
          className="jg-btn--ghost jg-space-mtms"
          onClick={onDismiss}
          type="button"
        >
          {dismissButtonText}
        </Button>
      </div>
    );
  },
);

ConfirmationModal.displayName = 'ConfirmationModal';

export default ConfirmationModal;
